<template>
  <roe-error-message
    :field="design.match_excludes_shiftdifferential_comp_yesno"
  >
    <roe-radio-input
      v-model="design.$model.match_excludes_shiftdifferential_comp_yesno"
    ></roe-radio-input>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
export default {
  name: "RoeEmployerMatchShiftDifferentialRadio",
  components: { RoeRadioInput, RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
